// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['cs_CZ']  = {
  "name": "cs_CZ",
  "day": {
    "abbrev": [
      "Ne",
      "Po",
      "Út",
      "St",
      "Čt",
      "Pá",
      "So"
    ],
    "full": [
      "Neděle",
      "Pondělí",
      "Úterý",
      "Středa",
      "Čtvrtek",
      "Pátek",
      "Sobota"
    ]
  },
  "month": {
    "abbrev": [
      "led",
      "úno",
      "bře",
      "dub",
      "kvě",
      "čen",
      "čec",
      "srp",
      "zář",
      "říj",
      "lis",
      "pro"
    ],
    "full": [
      "leden",
      "únor",
      "březen",
      "duben",
      "květen",
      "červen",
      "červenec",
      "srpen",
      "září",
      "říjen",
      "listopad",
      "prosinec"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%-d.%-m.%Y",
  "time24": "%H:%M:%S",
  "dateTime": "%a %-d. %B %Y, %H:%M:%S %Z",
  "time12": "%I:%M:%S",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

